export const FETCH_BILLING_USER_REQUEST = 'FETCH_BILLING_USER_REQUEST';
export const FETCH_BILLING_USER_SUCCESS = 'FETCH_BILLING_USER_SUCCESS';
export const FETCH_BILLING_USER_FAILURE = 'FETCH_BILLING_USER_FAILURE';

export const ADD_PROFILE_REQUEST = 'ADD_PROFILE_REQUEST';
export const ADD_PROFILE_SUCCESS = 'ADD_PROFILE_SUCCESS';
export const ADD_PROFILE_FAILURE = 'ADD_PROFILE_FAILURE';

export const FETCH_USER_PROFILES_REQUEST = 'FETCH_USER_PROFILES_REQUEST';
export const FETCH_USER_PROFILES_SUCCESS = 'FETCH_USER_PROFILES_SUCCESS';
export const FETCH_USER_PROFILES_FAILURE = 'FETCH_USER_PROFILES_FAILURE';

export const ADD_DEBITDIRECT_START_REQUEST = 'ADD_DEBITDIRECT_START_REQUEST';
export const ADD_DEBITDIRECT_START_SUCCESS = 'ADD_DEBITDIRECT_START_SUCCESS';
export const ADD_DEBITDIRECT_START_FAILURE = 'ADD_DEBITDIRECT_START_FAILURE';

export const ADD_DEBITDIRECT_END_REQUEST = 'ADD_DEBITDIRECT_END_REQUEST';
export const ADD_DEBITDIRECT_END_SUCCESS = 'ADD_DEBITDIRECT_END_SUCCESS';
export const ADD_DEBITDIRECT_END_FAILURE = 'ADD_DEBITDIRECT_END_FAILURE';

export const SET_PROFILE_DEFAULT_REQUEST = 'SET_PROFILE_DEFAULT_REQUEST';
export const SET_PROFILE_DEFAULT_SUCCESS = 'SET_PROFILE_DEFAULT_SUCCESS';
export const SET_PROFILE_DEFAULT_FAILURE = 'SET_PROFILE_DEFAULT_FAILURE';

export const UPDATE_PROFILE_DATA_REQUEST = 'UPDATE_PROFILE_DATA_REQUEST';
export const UPDATE_PROFILE_DATA_SUCCESS = 'UPDATE_PROFILE_DATA_SUCCESS';
export const UPDATE_PROFILE_DATA_FAILURE = 'UPDATE_PROFILE_DATA_FAILURE';

export const UPDATE_PROFILE_PICTURE_REQUEST = 'UPDATE_PROFILE_PICTURE_REQUEST';
export const UDPATE_PROFILE_PICTURE_SUCCESS = 'UDPATE_PROFILE_PICTURE_SUCCESS';
export const UPDATE_PROFILE_PICTURE_FAILURE = 'UPDATE_PROFILE_PICTURE_FAILURE';

export const DELETE_PROFILE_PICTURE_REQUEST = 'DELETE_PROFILE_PICTURE_REQUEST';
export const DELETE_PROFILE_PICTURE_SUCCESS = 'DELETE_PROFILE_PICTURE_SUCCESS';
export const DELETE_PROFILE_PICTURE_FAILURE = 'DELETE_PROFILE_PICTURE_FAILURE';

export const SET_DEFAULT_PAYMENT_REQUEST = 'SET_DEFAULT_PAYMENT_REQUEST';
export const SET_DEFAULT_PAYMENT_SUCCESS = 'SET_DEFAULT_PAYMENT_SUCCESS';
export const SET_DEFAULT_PAYMENT_FAILURE = 'SET_DEFAULT_PAYMENT_FAILURE';

export const DELETE_PAYMENT_METHOD_REQUEST = 'DELETE_PAYMENT_METHOD_REQUEST';
export const DELETE_PAYMENT_METHOD_SUCCESS = 'DELETE_PAYMENT_METHOD_SUCCESS';
export const DELETE_PAYMENT_METHOD_FAILURE = 'DELETE_PAYMENT_METHOD_FAILURE';

export const ADD_PAYMENT_METHOD_REQUEST = 'ADD_PAYMENT_METHOD_REQUEST';
export const ADD_PAYMENT_METHOD_SUCCESS = 'ADD_PAYMENT_METHOD_SUCCESS';
export const ADD_PAYMENT_METHOD_FAILURE = 'ADD_PAYMENT_METHOD_FAILURE';

export const ADD_MEMBER_PROFILE_REQUEST = 'ADD_MEMBER_PROFILE_REQUEST';
export const ADD_MEMBER_PROFILE_SUCCESS = 'ADD_MEMBER_PROFILE_SUCCESS';
export const ADD_MEMBER_PROFILE_FAILURE = 'ADD_MEMBER_PROFILE_FAILURE';

export const ACTIVATE_PROFILE_REQUEST = 'ACTIVATE_PROFILE_REQUEST';
export const ACTIVATE_PROFILE_SUCCESS = 'ACTIVATE_PROFILE_SUCCESS';
export const ACTIVATE_PROFILE_FAILURE = 'ACTIVATE_PROFILE_FAILURE';

export const UPDATE_MEMBER_REQUEST = 'UPDATE_MEMBER_REQUEST';
export const UPDATE_MEMBER_SUCCESS = 'UPDATE_MEMBER_SUCCESS';
export const UDPATE_MEMBER_FAILURE = 'UDPATE_MEMBER_FAILURE';

export const DELETE_MEMBER_REQUEST = 'DELETE_MEMBER_REQUEST';
export const DELETE_MEMBER_SUCCESS = 'DELETE_MEMBER_SUCCESS';
export const DELETE_MEMBER_FAILURE = 'DELETE_MEMBER_FAILURE';

export const SEND_INVITATION_REQUEST = 'SEND_INVITATION_REQUEST';
export const SEND_INVITATION_SUCCESS = 'SEND_INVITATION_SUCCESS';
export const SEND_INVITATION_FAILURE = 'SEND_INVITATION_FAILURE';

export const FETCH_INVOICES_REQUEST = 'FETCH_INVOICES_REQUEST';
export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';
export const FETCH_INVOICES_FAILURE = 'FETCH_INVOICES_FAILURE';

export const DOWNLOAD_INVOICE_REQUEST = 'DOWNLOAD_INVOICE_REQUEST';
export const DOWNLOAD_INVOICE_SUCCESS = 'DOWNLOAD_INVOICE_SUCCESS';
export const DOWNLOAD_INVOICE_FAILURE = 'DOWNLOAD_INVOICE_FAILURE';

export const DOWNLOAD_INVOICE_ZIP_REQUEST = 'DOWNLOAD_INVOICE_ZIP_REQUEST';
export const DOWNLOAD_INVOICE_ZIP_SUCCESS = 'DOWNLOAD_INVOICE_ZIP_SUCCESS';
export const DOWNLOAD_INVOICE_ZIP_FAILURE = 'DOWNLOAD_INVOICE_ZIP_FAILURE';
